export const imagePath = (image: string) => {
  const path = process.env.NEXT_PUBLIC_STRAPI_IMAGES;
  if (path && path.length) {
    return path + image;
  }
  return image;
};